import { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../App';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Image, Video, Calendar, Star } from 'lucide-react';

const Dashboard = () => {
  const [stats, setStats] = useState({
    total_bookings: 0,
    total_reviews: 0,
    total_photos: 0,
    total_videos: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await axios.get(`${API}/dashboard/stats`);
      if (response.data.success) {
        setStats(response.data.stats);
      }
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setLoading(false);
    }
  };

  const statCards = [
    {
      title: 'Total Bookings',
      value: stats.total_bookings,
      icon: Calendar,
      color: 'text-blue-600',
      bgColor: 'bg-blue-50',
    },
    {
      title: 'Total Reviews',
      value: stats.total_reviews,
      icon: Star,
      color: 'text-yellow-600',
      bgColor: 'bg-yellow-50',
    },
    {
      title: 'Photos',
      value: stats.total_photos,
      icon: Image,
      color: 'text-green-600',
      bgColor: 'bg-green-50',
    },
    {
      title: 'Videos',
      value: stats.total_videos,
      icon: Video,
      color: 'text-purple-600',
      bgColor: 'bg-purple-50',
    },
  ];

  if (loading) {
    return <div className="text-center py-12">Loading...</div>;
  }

  return (
    <div className="space-y-6" data-testid="dashboard-container">
      <div>
        <h1 className="text-3xl font-bold text-gray-800">Dashboard</h1>
        <p className="text-gray-600 mt-1">Welcome to Himali Khim Homestay Admin Panel</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {statCards.map((stat) => {
          const Icon = stat.icon;
          return (
            <Card key={stat.title} className="hover:shadow-lg transition-shadow" data-testid={`stat-card-${stat.title.toLowerCase().replace(' ', '-')}`}>
              <CardHeader className="flex flex-row items-center justify-between pb-2">
                <CardTitle className="text-sm font-medium text-gray-600">
                  {stat.title}
                </CardTitle>
                <div className={`${stat.bgColor} p-2 rounded-lg`}>
                  <Icon className={`${stat.color}`} size={20} />
                </div>
              </CardHeader>
              <CardContent>
                <div className="text-3xl font-bold text-gray-800">{stat.value}</div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      <Card className="mt-8">
        <CardHeader>
          <CardTitle>Quick Links</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <a
              href="/media"
              className="p-4 border rounded-lg hover:bg-gray-50 transition-colors"
              data-testid="quick-link-media"
            >
              <h3 className="font-semibold text-green-700">Upload Media</h3>
              <p className="text-sm text-gray-600 mt-1">Add photos and videos of your homestay</p>
            </a>
            <a
              href="/bookings"
              className="p-4 border rounded-lg hover:bg-gray-50 transition-colors"
              data-testid="quick-link-bookings"
            >
              <h3 className="font-semibold text-green-700">Manage Bookings</h3>
              <p className="text-sm text-gray-600 mt-1">View and manage guest bookings</p>
            </a>
            <a
              href="/reviews"
              className="p-4 border rounded-lg hover:bg-gray-50 transition-colors"
              data-testid="quick-link-reviews"
            >
              <h3 className="font-semibold text-green-700">Add Reviews</h3>
              <p className="text-sm text-gray-600 mt-1">Import and manage guest reviews</p>
            </a>
            <a
              href="/payment"
              className="p-4 border rounded-lg hover:bg-gray-50 transition-colors"
              data-testid="quick-link-payment"
            >
              <h3 className="font-semibold text-green-700">Payment Info</h3>
              <p className="text-sm text-gray-600 mt-1">View UPI QR and bank details</p>
            </a>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Dashboard;